import { useTheme } from '@material-ui/core';

const useFrameStyles = () => {
	const theme = useTheme();

	return {
		base: {
            border: '1px solid #c5c5c5',
            borderRadius: '5px',
            padding: '1px 14px',
            fontSize: '16px',
            color: theme.palette.text.primary
		},
		focus: {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px',
            padding: '0px 13px'
        },
		invalid: {
            borderColor: theme.palette.error.main
        },
		placeholder: {
			base: {
                color: theme.palette.text.secondary
			},
		}
	};
};

export default useFrameStyles;
